module.exports = __webpack_public_path__ + "img/x2.f54977c1.jpg";